import * as React from 'react';
const SvgYoutubeSkippable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
      <path
        fill="#F06050"
        d="M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
      />
      <path
        fill="#fff"
        d="M14.597 11.096 8.179 7.01c-.55-.351-.82-.523-1.046-.51a.64.64 0 0 0-.317.104.6.6 0 0 0-.178.165c-.138.179-.138.502-.138 1.142v8.178c0 .647 0 .963.138 1.142a.67.67 0 0 0 .495.268c.227.014.502-.158 1.046-.509l6.418-4.092c.475-.303.709-.454.791-.647a.7.7 0 0 0 0-.523c-.082-.192-.316-.344-.791-.646zM17.473 6.686q-.03-.052-.07-.096a.3.3 0 0 0-.082-.055c-.076-.034-.172-.034-.365-.034h-.275c-.192 0-.289 0-.364.034a.36.36 0 0 0-.152.151.5.5 0 0 0-.034.227V16.95c0 .193 0 .289.034.364a.36.36 0 0 0 .152.152c.075.034.172.034.364.034h.275c.11 0 .186 0 .248-.007a.24.24 0 0 0 .11-.027.36.36 0 0 0 .152-.151c.034-.076.034-.172.034-.365V7.051c0-.193 0-.289-.034-.365z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgYoutubeSkippable;
